import React from 'react';
import '../styles/PlanetsBackground.css'; // nuovo CSS separato
import redPlanet from '../assets/hiding/hiding-planet-red.png';
import bluePlanet from '../assets/hiding/hiding-planet-blue.png';
import greenPlanet from '../assets/hiding/hiding-planet-green.png';
import greyPlanet from '../assets/hiding/hiding-planet-grey.png';
import purplePlanet from '../assets/hiding/hiding-planet-purple.png';
import orangePlanet from '../assets/hiding/hiding-planet-orange.png';
import brownPlanet from '../assets/hiding/hiding-planet-brown.png';
import StarBackground from "./StarBackground";

const planets = [
    { color: 'red',    src: redPlanet },
    { color: 'blue',   src: bluePlanet },
    { color: 'green',  src: greenPlanet },
    { color: 'grey',   src: greyPlanet },
    { color: 'purple', src: purplePlanet },
    { color: 'orange', src: orangePlanet },
    { color: 'brown',  src: brownPlanet },
];

export default function PlanetsBackground() {
    return (
        <div className="planets-bg">
            <StarBackground />
            {planets.map((planet) => (
                <div key={planet.color} className={`planet-absolute planet-${planet.color}`}>
                    <img src={planet.src} alt={`${planet.color} planet`} className="planet-img" />
                </div>
            ))}
        </div>
    );
}
